// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9i-4";
export var collapsed = "_9i-1";
export var headerBar = "_9i-0";
export var leftHeaderContent = "_9i-3";
export var subjectContainer = "_9i-2";